module.exports = __webpack_public_path__ + "static/media/tpn-events-v2-wireframes.b3f6ceb8.png";